import { createFileRoute } from '@tanstack/react-router';
import { useState } from 'react';
import { ActionButton } from '@/components/ActionButton';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { FloorPlanEditor } from './FloorPlanEditor';

export const Route = createFileRoute('/r/$restaurantId/s/floor-plans')({
  component: FloorPlansPage,
});

function FloorPlansPage() {
  const [open, setOpen] = useState(false);

  return (
    <>
      {open && <FloorPlanEditor onClose={() => setOpen(false)} />}

      <Card>
        <CardHeader>
          <CardTitle>Floor plans</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <p className="text-sm text-muted-foreground">
            Setup a visual floor plan to assign orders to tables.
          </p>
          <ActionButton variant="outline" onClick={() => setOpen(true)}>
            Edit floor plan
          </ActionButton>
        </CardContent>
      </Card>
    </>
  );
}
